import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { Country, Installer, Language } from '@ubie/core';
import { AccountRegistrationSliderEvent } from '../../../interfaces/account-registration-slider-event.interface';

@Component({
  selector: 'acl-registration',
  standalone: false,
  templateUrl: './registration.component.html',
  styleUrl: './registration.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegistrationComponent {
  readonly currentStep = signal<number>(0);

  readonly installer = signal<Installer>({
    id: 0,
    firstname: '',
    lastname: '',
    fullname: '',
    streetNr: '',
    postalCode: '',
    city: '',
    telephone: '',
    email: '',
    vatno: '',
    companyname: '',
    activated: false,
    confirmed: false,
    lastLogin: new Date().toISOString(),
    password: '',
    newsletter: false,

    // Initialize with proper Language object with database ID
    language: { id: 1, name: 'English', culture: 'en-GB' } as Language,

    // Using the Country type as recommended (deprecated string handled)
    country: { id: '', name: '' } as Country,
  });

  updateStep($event: AccountRegistrationSliderEvent): void {
    this.currentStep.set($event.slideNo);
    if ($event.slideNo !== 0 && $event.slideNo !== 1 && $event.slideNo !== 3) {
      this.installer.set($event.user as Installer);
    }
  }
}
